import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HousingActions = createActionGroup({
    source: 'Margin Calculator - Housing',
    events: {
        revealHousingDetailsClicked: emptyProps(),
        setHousingSelected: props<{ housingSelected: boolean }>(),
        resetHousingFields: props<{ moveInDate: Date; moveOutDate: Date }>(),
        setHousingType: props<{ housingTypeId: number }>(),
        // Apartment and Hotel
        setContinuedHousing: props<{ continuedHousing: boolean }>(),
        setMonthlyRent: props<{ monthlyHousing: number; extendedStayHotel: number }>(),
        setMoveInDate: props<{ moveInDate: Date }>(),
        setMoveOutDate: props<{ moveOutDate: Date }>(),
        setFamilyMemberSelected: props<{ selected: boolean }>(),
        setFamilyMemberRelationship: props<{ relationship: string }>(),
        setFamilyMemberName: props<{ name: string }>(),
        setFamilyMemberAge: props<{ age: number }>(),
        setFamilyMemberAdditionalNotes: props<{ additionalNotes: string }>(),
        setPetSelected: props<{ selected: boolean }>(),
        setPetType: props<{ petType: number }>(),
        setPetWeight: props<{ weight: number }>(),
        setPetAge: props<{ age: number }>(),
        setPetBreed: props<{ breed: string }>(),
        // Apartment
        setBedrooms: props<{ bedrooms: number }>(),
        setMoveOutExpenses: props<{ moveOutExpenses: number }>(),
        setFurnitureDelivery: props<{ furnitureDelivery: number }>(),
        setFurniture: props<{ furniture: number }>(),
        setUtilities: props<{ utilities: number }>(),
        setHousewareSelected: props<{ housewareId: number; selected: boolean; duplicationCheck: boolean }>(),
        setOtherHousewareTitle: props<{ title: string }>(),
        setOtherHousewareCost: props<{ cost: number }>(),
        setFurnitureUtilitiesExpenses: props<{
            moveOutExpenses: number;
            furnitureDelivery: number;
            furniture: number;
            utilities: number;
        }>(),
        // WFD Sample Margin
        setDefaultHousingForWFDSample: props<{ housingSelected: boolean }>()
    }
});
